import { FC } from "react";
import { IconPropsType } from ".";

export const PdfBadge: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? 24}
      height={props.size ?? 24}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.92383 16.0002C2.92383 10.3769 7.48238 5.81836 13.1056 5.81836H20.742C26.3653 5.81836 30.9238 10.3769 30.9238 16.0002C30.9238 21.6234 26.3653 26.182 20.742 26.182H13.1056C7.48238 26.182 2.92383 21.6234 2.92383 16.0002Z"
        fill="#FFF4F4"
      />
      <path
        d="M10.7723 17.3462V19.3941H9.31832V13.3622H11.7249C12.1877 13.3622 12.5966 13.447 12.9514 13.6167C13.3062 13.7864 13.58 14.0281 13.7729 14.3418C13.9683 14.6555 14.066 15.0116 14.066 15.4101C14.066 15.9963 13.8551 16.4656 13.4335 16.8178C13.0144 17.1701 12.4371 17.3462 11.7018 17.3462H10.7723ZM10.7723 16.2239H11.7249C12.0078 16.2239 12.2225 16.1544 12.369 16.0156C12.5181 15.8742 12.5927 15.6749 12.5927 15.4178C12.5927 15.135 12.5168 14.91 12.3652 14.7429C12.2135 14.5732 12.0065 14.487 11.7442 14.4845H10.7723V16.2239Z"
        fill="#FF6969"
      />
      <path
        d="M14.8451 19.3941V13.3622H16.7889C17.3211 13.3622 17.7993 13.483 18.2236 13.7247C18.6504 13.9664 18.9834 14.3083 19.2225 14.7506C19.4616 15.1903 19.5824 15.6826 19.585 16.2277V16.5054C19.585 17.0582 19.468 17.5544 19.2341 17.9941C19.0026 18.4312 18.6748 18.7732 18.2506 19.02C17.8263 19.2668 17.3532 19.3915 16.8313 19.3941H14.8451ZM16.2991 14.4845V18.2757H16.8043C17.2208 18.2757 17.5409 18.1278 17.7646 17.8321C17.9909 17.5339 18.104 17.0916 18.104 16.5054V16.247C18.104 15.6634 17.9909 15.2237 17.7646 14.928C17.5409 14.6323 17.2157 14.4845 16.7889 14.4845H16.2991Z"
        fill="#FF6969"
      />
      <path
        d="M24.1293 16.9914H21.7844V19.3941H20.3304V13.3622H24.3646V14.4845H21.7844V15.8729H24.1293V16.9914Z"
        fill="#FF6969"
      />
    </svg>
  );
};

export const PdfBadgeGrey: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? 24}
      height={props.size ?? 24}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.92383 16.0002C2.92383 10.3769 7.48238 5.81836 13.1056 5.81836H20.742C26.3653 5.81836 30.9238 10.3769 30.9238 16.0002C30.9238 21.6234 26.3653 26.182 20.742 26.182H13.1056C7.48238 26.182 2.92383 21.6234 2.92383 16.0002Z"
        fill="#F8F8F8"
      />
      <path
        d="M10.7723 17.3462V19.3941H9.31832V13.3622H11.7249C12.1877 13.3622 12.5966 13.447 12.9514 13.6167C13.3062 13.7864 13.58 14.0281 13.7729 14.3418C13.9683 14.6555 14.066 15.0116 14.066 15.4101C14.066 15.9963 13.8551 16.4656 13.4335 16.8178C13.0144 17.1701 12.4371 17.3462 11.7018 17.3462H10.7723ZM10.7723 16.2239H11.7249C12.0078 16.2239 12.2225 16.1544 12.369 16.0156C12.5181 15.8742 12.5927 15.6749 12.5927 15.4178C12.5927 15.135 12.5168 14.91 12.3652 14.7429C12.2135 14.5732 12.0065 14.487 11.7442 14.4845H10.7723V16.2239Z"
        fill="#BFBFBF"
      />
      <path
        d="M14.8451 19.3941V13.3622H16.7889C17.3211 13.3622 17.7993 13.483 18.2236 13.7247C18.6504 13.9664 18.9834 14.3083 19.2225 14.7506C19.4616 15.1903 19.5824 15.6826 19.585 16.2277V16.5054C19.585 17.0582 19.468 17.5544 19.2341 17.9941C19.0026 18.4312 18.6748 18.7732 18.2506 19.02C17.8263 19.2668 17.3532 19.3915 16.8313 19.3941H14.8451ZM16.2991 14.4845V18.2757H16.8043C17.2208 18.2757 17.5409 18.1278 17.7646 17.8321C17.9909 17.5339 18.104 17.0916 18.104 16.5054V16.247C18.104 15.6634 17.9909 15.2237 17.7646 14.928C17.5409 14.6323 17.2157 14.4845 16.7889 14.4845H16.2991Z"
        fill="#BFBFBF"
      />
      <path
        d="M24.1293 16.9914H21.7844V19.3941H20.3304V13.3622H24.3646V14.4845H21.7844V15.8729H24.1293V16.9914Z"
        fill="#BFBFBF"
      />
    </svg>
  );
};
